import type { ComparacaoPublicacoesResponse, PublicacaoDetalheResponse, PublicacaoResponse } from '@triade/contracts';
import { useConsulta } from './base';

/** Intervalo de datas ISO ("2026-12-01"), inclusive nos dois lados. Ausente = sem filtro. */
export interface PeriodoPublicacoes {
  de?: string;
  ate?: string;
}

/**
 * GET /precificacao/publicacoes?de=&ate=: sem `de`/`ate` traz o historico todo (mais recentes primeiro); com eles, so as
 * publicacoes que tocam o intervalo (o calendario pede o mes visivel).
 */
export function useListaPublicacoes(periodo: PeriodoPublicacoes = {}, ativo = true) {
  return useConsulta<PublicacaoResponse[]>(['precificacao', 'publicacoes', 'lista'], '/precificacao/publicacoes', {
    query: { de: periodo.de, ate: periodo.ate },
    ativo,
  });
}

/** GET /precificacao/publicacoes/:id: snapshot completo (precos, escopo e parametros gravados na hora). */
export function usePublicacaoDetalhe(id: string | null) {
  return useConsulta<PublicacaoDetalheResponse>(
    ['precificacao', 'publicacoes', 'detalhe', id],
    `/precificacao/publicacoes/${id ?? ''}`,
    { ativo: id !== null },
  );
}

/** GET /precificacao/publicacoes/comparar?a=&b=: linhas com precoA, precoB, diferenca e variacao ja calculados pela API. */
export function useCompararPublicacoes(a: string | null, b: string | null) {
  return useConsulta<ComparacaoPublicacoesResponse>(
    ['precificacao', 'publicacoes', 'comparar', a, b],
    '/precificacao/publicacoes/comparar',
    { query: { a: a ?? undefined, b: b ?? undefined }, ativo: a !== null && b !== null },
  );
}
